import { QuestionCircleOutlined } from '@ant-design/icons';
import { FormValidatorBuilder } from '../../../../../validator/form-builder/FormValidatorBuilder.ts';
import { getParentValidationScope } from '../../../../../validator/utils/getParentValidationScope.ts';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { type IQuestionWidget } from './IQuestionWidget.ts';
import { QuestionWidgetComponent } from './QuestionWidgetComponent.tsx';
import {
  QuestionWidgetConfigComponent,
  QuestionWidgetConfigSchema,
} from './QuestionWidgetConfigComponent.tsx';

/**
 * Tipo del Widget "Quesito"
 */
export const QuestionWidgetType: IWidgetType<IQuestionWidget> = {
  type: WidgetType.Question,
  mainType: WidgetMainType.Container,
  category: WidgetCategory.Container,
  name: 'Quesito',
  icon: <QuestionCircleOutlined />,
  // Questo wiget non è al momento supportato in nessun tipo di configurazione
  supportedSectionTypes: [],
  hasValue: false,
  formComponent: QuestionWidgetComponent,
  createFormSchema: ({ widget, section, page, parentScope }) => {
    const widgetScope = getParentValidationScope(widget, parentScope);
    return FormValidatorBuilder.createWidgetsSchemaShape(
      widget.children,
      section,
      page,
      widgetScope,
    );
  },
  configComponent: QuestionWidgetConfigComponent,
  configValidator: QuestionWidgetConfigSchema,
  previewComponent: QuestionWidgetComponent,
  translationSchema: tran.widget({
    title: tran.rte(),
    helpText: tran.rte(),
    description: tran.rte(),
  }),
  rules: [],
};
